import { ChangeEvent } from "react";
import { KeyValueItem, newKeyValueItem } from "../../../utils/keyValueItems";

interface KeyValueListEditorProps {
  title: string;
  addLabel: string;
  items: KeyValueItem[];
  onChange: (items: KeyValueItem[]) => void;
  keyPlaceholder?: string;
  valuePlaceholder?: string;
  valueType?: "text" | "password" | "url";
  idPrefix: string;
}

const KeyValueListEditor = ({
  title,
  addLabel,
  items,
  onChange,
  keyPlaceholder = "Name",
  valuePlaceholder = "Value",
  valueType = "text",
  idPrefix,
}: KeyValueListEditorProps) => {
  const updateItem = (
    id: string,
    field: "key" | "value",
    value: string,
  ) => {
    onChange(
      items.map((item) =>
        item.id === id ? { ...item, [field]: value } : item,
      ),
    );
  };

  const removeItem = (id: string) => {
    onChange(items.filter((item) => item.id !== id));
  };

  const addItem = () => {
    onChange([...items, newKeyValueItem()]);
  };

  return (
    <section className="ic-stage-form-section ic-kv-section">
      <h3 className="ic-stage-form-section-title">{title}</h3>

      <button
        type="button"
        className="ic-kv-add-btn"
        onClick={addItem}
      >
        + {addLabel}
      </button>

      {items.length > 0 && (
        <div className="ic-kv-table">
          <div className="ic-kv-table-head" aria-hidden="true">
            <span>Name</span>
            <span>Value</span>
            <span />
          </div>
          {items.map((item, index) => (
            <div className="ic-kv-table-row" key={item.id}>
              <input
                id={`${idPrefix}-key-${index}`}
                type="text"
                className="form-control form-control-sm ic-stage-form-input"
                value={item.key}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  updateItem(item.id, "key", e.target.value)
                }
                placeholder={keyPlaceholder}
                aria-label={`${title} name ${index + 1}`}
              />
              <input
                id={`${idPrefix}-value-${index}`}
                type={valueType}
                className="form-control form-control-sm ic-stage-form-input"
                value={item.value}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  updateItem(item.id, "value", e.target.value)
                }
                placeholder={valuePlaceholder}
                aria-label={`${title} value ${index + 1}`}
                autoComplete="off"
              />
              <button
                type="button"
                className="ic-kv-remove-btn"
                onClick={() => removeItem(item.id)}
                aria-label={`Remove ${title} row ${index + 1}`}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default KeyValueListEditor;
